import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
import * as _this from './schema.js';
export var loadData = async () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        await import('../data/schema-added.json').then((data) => JSONLD.parse(data));
        return import('../data/schema.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        await import('../data/schema-added.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
        //@ts-ignore
        return import('../data/schema.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
//NOTE: we have changed the usual namespace https://schema.org/ to http://schema.org/ because tools like jsonld will convert all URI's to HTTP
//for now, our approach is therefor to convert to & use http versions only. schema.json has been adjusted too, and all namespaces in other files should use http://schema.org
export var ns = createNameSpace('http://schema.org/');
export var _self = ns('');
// Classes
export var DataType = ns('DataType');
export var CreativeWork = ns('CreativeWork');
export var Person = ns('Person');
export var VisualArtwork = ns('VisualArtwork');
export var Project = ns('Project');
export var PropertyValue = ns('PropertyValue');
export var Action = ns('Action');
export var ImageObject = ns('ImageObject');
export var Code = ns('Code');
export var House = ns('House');
export var City = ns('City');
export var Place = ns('Place');
export var Country = ns('Country');
export var Event = ns('Event');
export var JoinAction = ns('JoinAction');
export var BefriendAction = ns('BefriendAction');
export var Organization = ns('Organization');
export var Accommodation = ns('Accommodation');
export var Room = ns('Room');
export var Apartment = ns('Apartment');
export var VideoObject = ns('VideoObject');
export var Conversation = ns('Conversation');
export var SubscribeAction = ns('SubscribeAction');
export var UpdateAction = ns('UpdateAction');
export var PlayAction = ns('PlayAction');
export var Answer = ns('Answer');
export var Comment = ns('Comment');
export var DefinedTerm = ns('DefinedTerm');
export var Intangible = ns('Intangible');
export var DefinedTermSet = ns('DefinedTermSet');
export var ItemList = ns('ItemList');
export var ListItem = ns('ListItem');
export var MediaObject = ns('MediaObject');
export var Observation = ns('Observation');
// Properties
export var artEdition = ns('artEdition');
export var artform = ns('artform');
export var artist = ns('artist');
export var artMedium = ns('artMedium');
export var dateCreated = ns('dateCreated');
export var datePublished = ns('datePublished');
export var familyName = ns('familyName');
export var givenName = ns('givenName');
export var birthDate = ns('birthDate');
export var birthPlace = ns('birthPlace');
export var artworkSurface = ns('artworkSurface');
export var colorist = ns('colorist');
export var depth = ns('depth');
export var height = ns('height');
export var inker = ns('inker');
export var letterer = ns('letterer');
export var penciler = ns('penciler');
export var width = ns('width');
export var additionalType = ns('additionalType');
export var alternateName = ns('alternateName');
export var gender = ns('gender');
export var hasOccupation = ns('hasOccupation');
export var homeLocation = ns('homeLocation');
export var description = ns('description');
export var disambiguatingDescription = ns('disambiguatingDescription');
export var identifier = ns('identifier');
export var image = ns('image');
export var mainEntityOfPage = ns('mainEntityOfPage');
export var name = ns('name');
export var potentialAction = ns('potentialAction');
export var sameAs = ns('sameAs');
export var subjectOf = ns('subjectOf');
export var url = ns('url');
export var codeValue = ns('codeValue');
export var containedInPlace = ns('containedInPlace');
export var containsPlace = ns('containsPlace');
export var AdministrativeArea = ns('AdministrativeArea');
export var Thing = ns('Thing');
export var contentUrl = ns('contentUrl');
export var latitude = ns('latitude');
export var longitude = ns('longitude');
export var actionStatus = ns('actionStatus');
export var accommodationCategory = ns('accommodationCategory');
export var about = ns('about');
export var telephone = ns('telephone');
export var startDate = ns('startDate');
export var endDate = ns('endDate');
export var affiliation = ns('affiliation');
export var attendee = ns('attendee');
export var location = ns('location');
export var event = ns('event');
export var agent = ns('agent');
export var participant = ns('participant');
export var object = ns('object');
export var faxNumber = ns('faxNumber');
export var email = ns('email');
export var legalName = ns('legalName');
export var superEvent = ns('superEvent');
export var address = ns('address');
export var member = ns('member');
export var honorificPrefix = ns('honorificPrefix');
export var endTime = ns('endTime');
export var members = ns('members');
export var founder = ns('founder');
export var postalCode = ns('postalCode');
export var areaServed = ns('areaServed');
export var startTime = ns('startTime');
export var teamID = ns('teamID');
export var knows = ns('knows');
export var parentItem = ns('parentItem');
export var text = ns('text');
export var isMarried = ns('isMarried');
export var skills = ns('skills');
export var inDefinedTermSet = ns('inDefinedTermSet');
export var hasDefinedTerm = ns('hasDefinedTerm');
export var jobTitle = ns('jobTitle');
export var itemListElement = ns('itemListElement');
export var position = ns('position');
export var item = ns('item');
export var previousItem = ns('previousItem');
export var nextItem = ns('nextItem');
export var usageInfo = ns('usageInfo');
export var copyrightNotice = ns('copyrightNotice');
export var creditText = ns('creditText');
export var value = ns('value');
export var propertyID = ns('propertyID');
export var variableMeasured = ns('variableMeasured');
export var observationDate = ns('observationDate');
export var observationAbout = ns('observationAbout');
export var dateDeleted = ns('dateDeleted');
export var dateModified = ns('dateModified');
export var addressCountry = ns('addressCountry');
export var addressRegion = ns('addressRegion');
export var addressLocality = ns('addressLocality');
export var streetAddress = ns('streetAddress');
export var creator = ns('creator');
export var headline = ns('headline');
export var childItem = ns('childItem');
export const schema = {
    // Classes
    Intangible,
    DataType,
    creditText,
    copyrightNotice,
    CreativeWork,
    usageInfo,
    Person,
    VisualArtwork,
    Project,
    PropertyValue,
    Action,
    ImageObject,
    Code,
    Event,
    JoinAction,
    BefriendAction,
    Organization,
    Accommodation,
    Room,
    Apartment,
    VideoObject,
    Conversation,
    SubscribeAction,
    UpdateAction,
    PlayAction,
    Answer,
    Comment,
    DefinedTerm,
    DefinedTermSet,
    ItemList,
    ListItem,
    Observation,
    House,
    Place,
    City,
    Country,
    AdministrativeArea,
    Thing,
    MediaObject,
    // Properties
    dateModified,
    dateDeleted,
    additionalType,
    alternateName,
    gender,
    description,
    teamID,
    disambiguatingDescription,
    identifier,
    image,
    mainEntityOfPage,
    name,
    headline,
    potentialAction,
    sameAs,
    subjectOf,
    url,
    artform,
    artist,
    artworkSurface,
    creator,
    colorist,
    depth,
    height,
    inker,
    containedInPlace,
    containsPlace,
    letterer,
    penciler,
    observationDate,
    variableMeasured,
    observationAbout,
    width,
    artEdition,
    artMedium,
    dateCreated,
    datePublished,
    birthDate,
    birthPlace,
    hasOccupation,
    homeLocation,
    familyName,
    givenName,
    propertyID,
    codeValue,
    contentUrl,
    latitude,
    longitude,
    telephone,
    honorificPrefix,
    actionStatus,
    accommodationCategory,
    about,
    knows,
    startDate,
    endDate,
    affiliation,
    attendee,
    location,
    event,
    agent,
    participant,
    object,
    faxNumber,
    email,
    address,
    legalName,
    superEvent,
    member,
    endTime,
    members,
    founder,
    postalCode,
    areaServed,
    startTime,
    parentItem,
    text,
    isMarried,
    skills,
    inDefinedTermSet,
    hasDefinedTerm,
    jobTitle,
    itemListElement,
    position,
    item,
    previousItem,
    nextItem,
    value,
    addressCountry,
    addressRegion,
    addressLocality,
    streetAddress,
    childItem,
};
linkedOntology(_this, ns, 'schema', loadData, [
    '../data/schema.json',
    '../data/schema-added.json',
]);
//# sourceMappingURL=schema.js.map